import { UnitType, unitTypeToString } from '../../models/IUnit.js';
import { formatPrice } from './priceLocale.js';
const COLLECTION_CATEGORY_ORDER = [
    UnitType.Hero,
    UnitType.Infantry,
    UnitType.Cavalry,
    UnitType.Beast,
    UnitType.Monster,
    UnitType.WarMachine,
    UnitType.Manifestation,
    UnitType.Terrain,
];
function findUnit(unitName, army) {
    return army.units.find((u) => u.name === unitName) ?? null;
}
export function exportCollectionText(list, scrolldexData, options) {
    const data = list.data;
    if (!data)
        return '';
    const includeTags = options?.includeTags ?? true;
    const pricingEnabled = data.pricingEnabled ?? false;
    const priceLocale = options?.priceLocale ?? 'us';
    const army = scrolldexData.armies[list.faction];
    const totalPoints = data.entries.reduce((sum, entry) => {
        const unit = army ? findUnit(entry.unitName, army) : null;
        return sum + (unit?.points ?? 0) * entry.count;
    }, 0);
    const totalUnits = data.entries.reduce((sum, e) => sum + e.count, 0);
    const lines = [];
    lines.push(`${list.name} ${totalPoints.toLocaleString()} pts`);
    if (pricingEnabled && data.lotPrice !== undefined) {
        const unitPriceTotal = data.entries.reduce((sum, e) => sum + (e.price ?? 0) * e.count, 0);
        const discount = unitPriceTotal > data.lotPrice ? unitPriceTotal - data.lotPrice : 0;
        let lotLine = `Lot Price: ${formatPrice(data.lotPrice, priceLocale)}`;
        if (discount > 0) {
            lotLine += ` (Lot Discount: ${formatPrice(discount, priceLocale)})`;
        }
        lines.push(lotLine);
    }
    lines.push('');
    lines.push(list.faction);
    lines.push(`Units: ${totalUnits}`);
    if (options?.listDescription && list.description) {
        lines.push('');
        lines.push(list.description);
    }
    for (const unitType of COLLECTION_CATEGORY_ORDER) {
        const groupEntries = data.entries.filter((entry) => {
            const unit = army ? findUnit(entry.unitName, army) : null;
            return unit ? unit.type === unitType : false;
        });
        if (groupEntries.length === 0)
            continue;
        lines.push('');
        lines.push(unitTypeToString({ type: unitType }));
        for (const entry of groupEntries) {
            const unit = army ? findUnit(entry.unitName, army) : null;
            const unitPoints = unit?.points ?? 0;
            let entryLine = `${entry.count}x ${entry.unitName}`;
            if (pricingEnabled) {
                if (entry.price !== undefined) {
                    const suffix = entry.count > 1 ? ' ea.' : '';
                    entryLine += ` - ${formatPrice(entry.price, priceLocale)}${suffix}`;
                }
            }
            else if (unitPoints > 0) {
                entryLine += ` (${unitPoints * entry.count})`;
            }
            lines.push(entryLine);
            if (includeTags && entry.tags.length > 0) {
                lines.push(`• ${entry.tags.join(', ')}`);
            }
        }
    }
    const unknownEntries = data.entries.filter((entry) => {
        const unit = army ? findUnit(entry.unitName, army) : null;
        return !unit;
    });
    if (unknownEntries.length > 0) {
        lines.push('');
        lines.push('Unknown');
        for (const entry of unknownEntries) {
            let entryLine = `${entry.count}x ${entry.unitName}`;
            if (pricingEnabled && entry.price !== undefined) {
                const suffix = entry.count > 1 ? ' ea.' : '';
                entryLine += ` - ${formatPrice(entry.price, priceLocale)}${suffix}`;
            }
            lines.push(entryLine);
            if (includeTags && entry.tags.length > 0) {
                lines.push(`• ${entry.tags.join(', ')}`);
            }
        }
    }
    const regimentsOfRenown = options?.regimentsOfRenown ?? [];
    if (regimentsOfRenown.length > 0) {
        lines.push('');
        lines.push('Regiments of Renown');
        for (const entry of regimentsOfRenown) {
            const ror = scrolldexData.regimentsOfRenown.find((r) => r.name === entry.name);
            let entryLine = `${entry.count}x ${entry.name}`;
            if (pricingEnabled) {
                if (entry.price !== undefined) {
                    const suffix = entry.count > 1 ? ' ea.' : '';
                    entryLine += ` - ${formatPrice(entry.price, priceLocale)}${suffix}`;
                }
            }
            else if (ror?.points) {
                entryLine += ` (${ror.points * entry.count})`;
            }
            lines.push(entryLine);
            if (includeTags && entry.tags.length > 0) {
                lines.push(`• ${entry.tags.join(', ')}`);
            }
        }
    }
    lines.push('');
    lines.push('Created with Sigdex: sigdex.io');
    if (options?.appVersion) {
        lines.push(`App Version: ${options.appVersion}`);
    }
    lines.push(`Server Version: ${scrolldexData.version.server}`);
    return lines.join('\n');
}
